import { useEffect, useRef, useState } from 'react';

import { Box } from '@mui/material';

import OperatorSessionFullPanel from '@components/operatorSession/OperatorSessionFullPanel';
import OperatorSessionMiniPanel from '@components/operatorSession/OperatorSessionMiniPanel';

const OperatorSessionContainer = () => {
    const [displayStateMini, setDisplayStateMini] = useState(false);
    const timer = useRef(null);

    const timeUntilMinifyMS = 6000;

    useEffect(() => {
        timer.current = setInterval(
            () => setDisplayStateMini(true),
            timeUntilMinifyMS,
        );
        return () => {
            clearInterval(timer.current);
        };
    }, []);

    return (
        <Box
            sx={{ zIndex: 10 }}
            onMouseEnter={() => {
                if (displayStateMini) {
                    setDisplayStateMini(false);
                } else {
                    clearInterval(timer.current);
                }
            }}
            onMouseLeave={() => {
                timer.current = setInterval(
                    () => setDisplayStateMini(true),
                    timeUntilMinifyMS,
                );
            }}>
            {displayStateMini ? (
                <OperatorSessionMiniPanel />
            ) : (
                <OperatorSessionFullPanel />
            )}
        </Box>
    );
};

export default OperatorSessionContainer;
